(() => {
    const SELECTORS = {
        card: '.video-item',
        trigger: '[data-tv-trigger]',
        modal: '[data-video-modal]',
        modalVideo: '.video-item__view-video',
        modalTitle: '.video-item__view-title',
        modalDescription: '.video-item__view-description',
        cardTitle: '.video-item__title',
        cardDescription: '.video-item__description',
        cardCta: '.video-item__cta',
        close: '[data-video-close]',
    };

    let modal = null;

    // Uploaded video files (Shopify Files / direct .mp4, .mov, .webm links)
    const isDirectVideo = (url) => {
      if (!url) return false;

      try {
        const parsedUrl = new URL(url, window.location.href);
        const path = parsedUrl.pathname.toLowerCase();

        return (
          path.startsWith('/videos/') ||
          /\.(mp4|mov|webm|m4v)$/.test(path)
        );
      } catch {
        return false;
      }
    };

    const getEmbedUrl = (url) => {
      if (!url) return '';

      try {
        const parsedUrl = new URL(url);
        const hostname = parsedUrl.hostname;

        if (hostname.includes('youtube.com') || hostname.includes('youtu.be')) {
            let videoId = null;

            // Standard watch URL
            if (parsedUrl.searchParams.get('v')) {
              videoId = parsedUrl.searchParams.get('v');
            }

            // Shorts URL: /shorts/{id}
            if (!videoId && parsedUrl.pathname.includes('/shorts/')) {
              videoId = parsedUrl.pathname.split('/shorts/')[1]?.split('?')[0];
            }

            // youtu.be/{id}
            if (!videoId && hostname.includes('youtu.be')) {
              videoId = parsedUrl.pathname.replace('/', '').split('?')[0];
            }

            if (videoId) {
              return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&autoplay=1&playsinline=1`;
            }
          }

        if (parsedUrl.hostname.includes('youtu.be')) {
          const videoId = parsedUrl.pathname.replace('/', '');
          return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1` : url;
        }

        if (parsedUrl.hostname.includes('vimeo.com')) {
          const videoId = parsedUrl.pathname.replace('/', '');
          return videoId ? `https://player.vimeo.com/video/${videoId}?autoplay=1` : url;
        }

        return url;
      } catch {
        return url;
      }
    };

    const createModal = () => {
      const existingModal = document.querySelector(SELECTORS.modal);

      if (existingModal) {
        return existingModal;
      }

      const modalElement = document.createElement('div');

      modalElement.className = 'video-item__view';
      modalElement.setAttribute('data-video-modal', '');
      modalElement.setAttribute('hidden', '');
      modalElement.classList.remove('is-open');

      modalElement.innerHTML = `
        <div class="video-item__view-overlay" data-video-close></div>

        <div class="video-item__view-dialog" role="dialog" aria-modal="true" aria-label="Video">
          <button tabindex="0" type="button" class="button button--close video-item__view-close" data-close="" aria-label="Close video" data-video-close>
            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" class="icon--s icon icon--close" fill="currentColor"><path d="M12.8536 2.85355C13.0488 2.65829 13.0488 2.34171 12.8536 2.14645C12.6583 1.95118 12.3417 1.95118 12.1464 2.14645L7.5 6.79289L2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L6.79289 7.5L2.14645 12.1464C1.95118 12.3417 1.95118 12.6583 2.14645 12.8536C2.34171 13.0488 2.65829 13.0488 2.85355 12.8536L7.5 8.20711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.20711 7.5L12.8536 2.85355Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg><span class="caption">Close</span>
          </button>

          <div class="video-item__view-video" data-video-modal-video></div>

          <div class="video-item__view-content">
            <h3 class="video-item__view-title" data-video-modal-title></h3>
            <div class="video-item__view-description" data-video-modal-description></div>
          </div>
        </div>
      `;

      document.body.appendChild(modalElement);

      return modalElement;
    };

    const clearModal = () => {
      if (!modal) return;

      const videoContainer = modal.querySelector(SELECTORS.modalVideo);
      const title = modal.querySelector(SELECTORS.modalTitle);
      const description = modal.querySelector(SELECTORS.modalDescription);

      if (videoContainer) {
        const playingVideo = videoContainer.querySelector('video');
        if (playingVideo) playingVideo.pause();
        videoContainer.innerHTML = '';
      }
      if (title) title.textContent = '';
      if (description) description.textContent = '';
    };

    const getVideoDataFromCard = (trigger) => {
        const card = trigger;//.closest(SELECTORS.card);

        if (!card) return null;

        const titleElement = card.querySelector(SELECTORS.cardTitle);
        const descriptionElement = card.querySelector(SELECTORS.cardDescription);
        const ctaElement = card.querySelector(SELECTORS.cardCta);

        return {
          url: ctaElement?.getAttribute('href') || '',
          title: titleElement?.textContent?.trim() || '',
          description: descriptionElement?.innerHTML?.trim() || '',
        };
    };

    const openModal = ({ url, title, description }) => {
      if (!modal) return;

      clearModal();

      const videoContainer = modal.querySelector(SELECTORS.modalVideo);
      const titleElement = modal.querySelector(SELECTORS.modalTitle );
      const descriptionElement = modal.querySelector(SELECTORS.modalDescription);

      if (videoContainer && url && isDirectVideo(url)) {
        // Uploaded video: play it right away in the site's own player
        const videoElement = document.createElement('video');
        videoElement.className = 'video-item__view-iframe';
        videoElement.src = url;
        videoElement.controls = true;
        videoElement.autoplay = true;
        videoElement.playsInline = true;
        videoElement.setAttribute('playsinline', '');
        videoElement.setAttribute('title', title || 'Video');
        videoElement.style.width = '100%';
        videoElement.style.height = '100%';
        videoElement.style.objectFit = 'contain';
        videoElement.style.backgroundColor = '#000';
        videoContainer.appendChild(videoElement);

        const playPromise = videoElement.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            // If the browser blocks sound, start muted instead
            videoElement.muted = true;
            videoElement.play().catch(() => {});
          });
        }
      } else {
        const embedUrl = getEmbedUrl(url);

        if (videoContainer && embedUrl) {
          videoContainer.innerHTML = `
            <iframe
              src="${embedUrl}"
              class="video-item__view-iframe"
              title="${title || 'Video'}"
              frameborder="0"
              allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          `;
        }
      }

      if (titleElement) {
        titleElement.textContent = title || '';
      }

      if (descriptionElement) {
        descriptionElement.innerHTML = description || '';
      }

      modal.removeAttribute('hidden');
      modal.classList.add('is-open');
      document.documentElement.classList.add('video-modal-open');
    };

    const closeModal = () => {
      if (!modal) return;

      modal.classList.remove('is-open');
      document.documentElement.classList.remove('video-modal-open');
      clearModal();
    };

    const bindEvents = () => {
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest(SELECTORS.trigger);

        if (trigger) {
            event.preventDefault();

            const videoData = getVideoDataFromCard(trigger);

            if (!videoData) return;

            openModal(videoData);

            return;
        }

        if (event.target.closest(SELECTORS.close)) {
          closeModal();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeModal();
        }
      });
    };

    const init = () => {
      const hasVideoTriggers = document.querySelector(SELECTORS.trigger);

      if (!hasVideoTriggers) return;

      modal = createModal();
      bindEvents();
    };

    document.addEventListener('DOMContentLoaded', init);
  })();
